<template>
  <div
    id="content-text">
    <v-divider></v-divider>

    <!-- Edit Form -->
    <form
      name="textContentItemForm"
      class="mt-5"
      v-if="tab === 'edit'"
      @submit.prevent="updateContentItem('textItemUpdate')">
      <v-textarea
        v-model="contentItem.content"
        hide-details
        outlined>
      </v-textarea>

      <div class="page-buttons d-flex my-5">
        <v-btn
          type="submit"
          color="primary">
          Save
        </v-btn>

        <v-btn
          @click="goToContentList"
          type="button"
          color="primary"
          class="mr-auto order-first"
          outlined>
          Cancel
        </v-btn>
      </div>
    </form>
    <!-- / Edit Form -->

    <!-- Revisions -->
    <Revisions
      v-if="tab === 'revisions'"
    />
    <!-- / Revisions -->
  </div>
</template>

<script>
import ContentItemMixin from '../mixin.content-item';
import Revisions from './Revisions.vue';

export default {
  name: 'ContentText',
  props: ['tab'],
  mixins: [
    ContentItemMixin,
  ],
  components: {
    Revisions,
  },
};
</script>

<style lang="scss">
#content-text {
  form {
    max-width: 500px;
  }
}
</style>
